(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
})((function () { 'use strict';

  /**
   * Section swapping functionality for .page-nav--wpbakery components. Depends on
   * default page-nav functionality. The below functionality swaps the page panels.
   *
   * @see _front.page-nav.js
   */
  (function(){
    // find first page-nav element (others are ignored)
    var pageNavElem = document.querySelector('.page-nav--wpbakery');
    if (!pageNavElem) return;

    // source/main content container
    var sourceElem = document.querySelector('.entry-content');

    // placeholder container (as to not disturb vc_section striping within source content container)
    var placeholderElem = document.createElement('div');
    placeholderElem.className = 'page-nav--placeholder';
    sourceElem.parentNode.appendChild(placeholderElem);

    // remove all vc_section elements from source container
    function clear() {
      sourceElem.querySelectorAll('.vc_section').forEach(function(elem){
        if (elem.matches('.vc_section--page-nav')) return;
        placeholderElem.appendChild(elem);
      });
    }

    // move ids into container
    function move(container, ids) {
      ids.forEach(function(id){
        container.appendChild(document.getElementById(id));
      });
    }

    // clone page-nav and place at bottom
    //document.querySelector('.hentry').appendChild(page_nav_section.cloneNode(true));

    var menuElem = pageNavElem.querySelector('.menu');
    var firstHash = menuElem.querySelector('.menu-link').getAttribute('href');
    function setActivePanel(hash) {
      hash = hash ? hash : firstHash;
      hash = '#' + hash.replace('#', '');
      var menuItemElem = menuElem.querySelector('[href="' + hash + '"]').closest('.menu-item');
      // clear and move sections
      var ids = menuItemElem.getAttribute('data-ids').split(',').map(function(id){
          return id.replace('#', '');
        });
        clear();
        move(sourceElem, ids);
    }

    // listen for hash changes
    window.addEventListener('hashchange', function(e){
      setActivePanel(window.location.hash);
    }, false);

    // onload hash check
    if (window.location.hash) setActivePanel(window.location.hash);
    // set first menu item hash active
    else setActivePanel(firstHash);
  })();

}));
